import { Box, Flex, Image, ImageProps } from '@chakra-ui/react';
import ImageDefault from 'src/assets/images/image-default.jpg';
import { ChakraFeatherIcon } from '@/components/ChakraFeatherIcon';
import { IconName } from '@ailibs/feather-react-ts';

type ImagePreviewProps = {
  imageProps?: Omit<ImageProps, 'src'>;
  src?: string;
  withoutHover?: boolean;
  actionAriaLabel?: string;
  actionIconName?: IconName;
  onActionClick?: () => void;
  deleteAriaLabel?: string;
  onDeleteClick?: () => void;
};

export const ImagePreview = (props: ImagePreviewProps) => {
  const {
    src = ImageDefault,
    withoutHover,
    imageProps,
    actionAriaLabel = '',
    actionIconName = 'edit-2',
    onActionClick,
    deleteAriaLabel = '',
    onDeleteClick,
  } = props;

  return (
    <Flex
      position='relative'
      _hover={
        withoutHover
          ? undefined
          : {
              '& > div': {
                visibility: 'visible',
                opacity: 1,
              },
            }
      }
    >
      <Image minW='80px' w='80px' minH='80px' h='80px' objectFit='cover' borderRadius='8px' src={src} {...imageProps} />

      <Box
        visibility='hidden'
        opacity={0}
        transition='0.2s'
        display='flex'
        flexDirection='column'
        justifyContent='center'
        alignItems='center'
        minW='80px'
        w='80px'
        minH='80px'
        h='80px'
        borderRadius='8px'
        position='absolute'
        left={0}
        top={0}
        css={{
          '&::before': {
            content: '""',
            width: '100%',
            height: '100%',
            position: 'absolute',
            left: '0',
            backgroundColor: 'var(--qgx-theme-colors-black)',
            opacity: '0.6',
            borderRadius: '8px',
          },

          '> svg': {
            color: 'var(--qgx-theme-colors-brand-500)',
            zIndex: 999,
          },
        }}
      >
        <Flex gap={2} zIndex={999}>
          {onActionClick && (
            <Box
              aria-label={actionAriaLabel}
              onClick={onActionClick}
              bg='white'
              _hover={{ bg: 'white' }}
              display='flex'
              justifyContent='center'
              alignItems='center'
              w='28px'
              h='28px'
              borderRadius='50%'
              cursor='pointer'
            >
              <ChakraFeatherIcon name={actionIconName} w='18px' color='brand.500' />
            </Box>
          )}

          {onDeleteClick && (
            <Box
              aria-label={deleteAriaLabel}
              onClick={onDeleteClick}
              bg='white'
              _hover={{ bg: 'white' }}
              display='flex'
              justifyContent='center'
              alignItems='center'
              w='28px'
              h='28px'
              borderRadius='50%'
              cursor='pointer'
            >
              <ChakraFeatherIcon name='trash-2' w='18px' color='red.500' />
            </Box>
          )}
        </Flex>
      </Box>
    </Flex>
  );
};
